export default {
  text: 'text',
  question: 'question',
  assessmentResult: 'assessmentResult',
  processError: 'processError',
  fetchError: 'fetchError',
  slider: 'slider',
  goalSelector: 'goalSelector'
};
